import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "reactstrap";
import AmazonProductListingFieldRow from "./AmazonProductListingFieldRow";
import FetchAllAssetsAsinWiseService from "../../../../../Service/OPSServices/AmazonProductListing_v1/FetchAllAssetsAsinWiseService";

import AssetsgalleryImges from "./AssetsGalleryImges";
import { connect } from "react-redux";
import CustomModal from "../../../../Components/Modals/CustomModal";

function AmazonProductListingGroupSection(props) {
  const [galleryImg, setGalleryImg] = useState();
  const [imagePopUpOPen, setImagePopUpOPen] = useState(false)
  const [selectedImages, setSelectedImages] = useState([]);
  const [slectedImgReplace,setSelectedReplace] = useState([]);

  useEffect(() => {
    let data = {
      asin: props.selectedAsin

    };
    FetchAllAssetsAsinWiseService(props.token, data).then((res) => {
      if (res) {
        setGalleryImg(res.fileList);
      }
    });
  }, []);
  const handleAction = (value) => {
    console.log(value)
    setSelectedReplace(value)
    setImagePopUpOPen(true)
  };

 
  const handleChange = () => {

    if (props.onFieldChange) {
  
      props.onFieldChange({
  field: slectedImgReplace.field,
  value: selectedImages.filePath
});
    }
  
    setImagePopUpOPen(false);
  };


  if (!props.fields || props.fields.length === 0) return null;

  return (
    <>
      <div className="group-section-container">
        {/* <div className="group-section-header">
          <span className="group-section-title">
            {props.title}
          </span>
          
         
        </div> */}

        <div className="group-section-body">
          {/* Frozen Header */}
          <Row className="g-2 px-3 py-2 border-bottom align-items-center m-0 group-section-col-headers"
          style={{
            position: "sticky",
            top: "243px", 
            zIndex: 99,
          }}>
              <Col md={2}>Field</Col> 
              <Col md={3}>Catalog</Col>
              <Col md={3}>Listing</Col>
              <Col md={4}>Edit</Col>
              {/* <Col md={1}>Status</Col> */}
            </Row>
       
            
            <div className="group-section-scroll-container">
              {props.fields.map((f, i) => (
                <AmazonProductListingFieldRow key={f && f.field ? f.field : i} field={f} action={handleAction} 
                onFieldChange={props.onFieldChange}
                changedFields={props.changedFields}
                />
              ))}
            </div>
          </div>
      </div>

      <CustomModal
        header={"Select Image"}
        isOpen={imagePopUpOPen}
        toggle={() => setImagePopUpOPen(!imagePopUpOPen)}
        size={"xl"}
        className='curve-popup'
      >
        {/* <Card className='card-of-problemarea p-2'> */}
        <AssetsgalleryImges galleryImg={galleryImg} 
        setGalleryImg={setGalleryImg} 
        selectedImages={selectedImages}
        setSelectedImages={setSelectedImages}
        handleSubmitFile={handleChange} />
        {/* </Card> */}
        </CustomModal>
    
    </>
  );
}

var mapStateToProps = function (state) {
  return { token: state.loggedUser.token };
};

export default connect(mapStateToProps)(AmazonProductListingGroupSection);